import React, { useMemo, useRef, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { RightOutlined, CopyOutlined } from '@ant-design/icons';
import Copy from '@/components/copy';
import { withRouter } from 'react-router-dom';
import { getQuery } from '@/common/utils';
import goto from '@/common/goto';
import env from '@/env';
import { useSlideMenuCollapse } from '@/hooks/useSlideMenuCollapsedChange';
import DetailHeaderInfoWrapper from '@/components/detail-header-info-wrapper';
import BtnPowerManage from '../components/btn-authority-management';

import Microapp from '@/components/micro-app';
import { useQueryHeader } from '@/apis/platform/header';
import roomApis from '@/apis/room/index';
import wareApis from '@/apis/ware/index';
import cateApi from '@/apis/cate/index';
import useHideBreadCrumbs from '@/components/bread-crumbs/use-hide-bread-crumbs';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import Container from '@/components/container';
import JdImg from '@/components/jd-img';

import './index.less';
import { Button, message, Tooltip } from 'antd';

/*****************
 * 门槛规则 - 设置 - 提报 *
 *****************/
const MaterialPoolRuleNew = withRouter((props) => {
  // 隐藏侧边栏
  useSlideMenuCollapse();
  const { channelId } = props.match.params;
  const poolId = getQuery('poolId');
  const ruleId = getQuery('ruleId');
  const blockId = getQuery('blockId');
  const activityId = getQuery('activityId');

  const from = getQuery('from');
  const status = getQuery('status');
  const query = useMemo(() => ({ channelId }), [channelId]);
  const [poolData, setPoolData] = useState({});
  const [showHeader, setShowHeader] = useState(true);
  const [permission, setPermission] = useState({});
  const [dailyData, setDailyData] = useState({});
  const [showNav, setShowNav] = useState(true);
  const [headerExtraProps, setHeaderExtraProps] = useState({});
  const history = useHistory();
  useHideBreadCrumbs();
  const pandoraRef = useRef();
  function customCrumb() {
    return (
      <div className="custom-crumb-fa">
        <div className="first-crumb text-crumb" onClick={() => goto.materialPoolManage(channelId).push()}>
          {'0' || '平台营销阵地'}
        </div>
        <div className="arrow">
          <RightOutlined />
        </div>
        <div className="last-crumb text-crumb">门槛规则</div>
      </div>
    );
  }

  const postDataObj = {
    poolId,
    ruleId,
  };
  if (!poolId) {
    delete postDataObj.poolId;
  }
  if (!ruleId) {
    delete postDataObj.ruleId;
  }
  const getExtra = () => {
    if (blockId) {
      return [
        {
          key: '收品池编号',
          value: (
            <Copy key="blockId" text={blockId} icon={<CopyOutlined className="activity-card-detail__icon-copy" />} />
          ),
        },
        {
          key: '素材组编号',
          value: (
            <Copy
              key="otherSystemGroupId"
              text={poolData.otherSystemGroupId}
              icon={<CopyOutlined className="activity-card-detail__icon-copy" />}
            />
          ),
        },
        {
          key: '收品类型',
          value: poolData.gatherType,
        },
        {
          key: '示意图',
          value: !!poolData.imageUrl ? (
            <Tooltip
              key="image"
              overlayStyle={{ minWidth: 260 }}
              title={<JdImg className="venue_jd_img" src={poolData.imageUrl} width="100%" height={147} />}
            >
              <a>查看</a>
            </Tooltip>
          ) : (
            '-'
          ),
        },
        {
          key: '收品池介绍',
          value: poolData.description,
        },
      ];
    }
    return [
      {
        key: '管理组组长',
        value: dailyData.leader,
      },
      {
        key: '活动ID',
        value: activityId,
      },
      {
        key: '活动时间',
        value: `${formateTimeStamp(dailyData.startTime, true)} 至 ${formateTimeStamp(dailyData.endTime, true)}`,
      },
    ];
  };
  const handelSaveRules = () => {
    if (pandoraRef.current && Object.keys(pandoraRef.current).length) {
      const saveRuleFunList = Object.keys(pandoraRef.current);
      const saveRule = pandoraRef.current.saveRules;
      if (typeof saveRule === 'function') {
        saveRule(
          (res) => {
            message.success('规则设置成功');
            setTimeout(() => {
              const params = decodeURIComponent(getQuery('query'));
              goto.dailyTiBaoVenueSetting(`${params}`).push();
            }, 2e3);
          },
          (res) => {
            message.error(res || '规则设置失败请稍后重试');
          }
        );
      }
    }
  };
  const batchParams = {
    status: status || 'new',
    poolType: 19,
    planCode: channelId, // 阵地id
    ref: pandoraRef,
    ruleId: ruleId || '',
    activityId: getQuery('activityId'), //
    blockId: getQuery('blockId'),
  };
  useEffect(() => {
    if (!activityId || !blockId) {
      setPoolData({});
      return;
    }
    roomApis
      .poolHeader({
        tibaoId: activityId,
        poolId: blockId,
      })
      .then(({ ret, msg, data }) => {
        if (ret === '0') {
          setPoolData(data);
        } else {
          message.error(msg);
        }
      });
  }, [activityId, blockId]);
  useEffect(() => {
    if (!activityId) {
      setDailyData({});
      return;
    }
    roomApis.getDetailByRoomId({ activityId }).then(({ ret, data, msg }) => {
      if (ret === '0') {
        cateApi.list({ pageSize: 100 }).then((res: any) => {
          if (ret === '0') {
            const dailyDatas = Object.assign({}, data, {
              categoryName:
                data.category &&
                data.category
                  .map((item: any) => res.data.categorys.find((cate: any) => cate.categoryId === Number(item)))
                  .filter((item: any) => item !== undefined)
                  .map((item: any) => item.categoryName),
            });
            setDailyData(dailyDatas);
          }
        });
      } else {
        message.error(msg);
      }
    });
  }, [activityId]);
  useEffect(() => {
    let roomId = dailyData?.roomId;
    if (!roomId) return;
    roomApis.dailyActPermission({ roomId }).then(({ ret, msg, data }) => {
      if (ret === '0') {
        setPermission(data);
      } else {
        message.error(msg);
      }
    });
  }, [dailyData.roomId]);

  const headerPermission = permission?.modules?.functions?.room_header;
  return (
    <ContextProviderMenus.Provider
      value={{
        children: props.children,
        setShowHeader,
        setShowNav,
        setHeaderExtraProps,
        roomId: dailyData.roomId,
        activityId: activityId,
        dailyData,
        permission,
      }}
    >
      <Container bg={false} padding={false} margin={false}>
        <div className="material-pool-rule-new-wrapper" ref={pandoraRef}>
          <div className="rule-new-header-fa">
            {/* {showHeader && (
              <DetailHeaderInfoWrapper
                extraInfo={getExtra()}
                btns={
                  <>
                    {headerPermission?.room_member_management === 1 && <BtnPowerManage roomId={dailyData.roomId} />}
                    {headerPermission?.room_info_modify === 1 && (
                      <Button
                        shape="round"
                        type="primary"
                        onClick={() => {
                          history.push(
                            `/activity-manage/myCreate/acoreCreateRoomActivity?roomId=${dailyData.roomId}&activityId=${activityId}`
                          );
                        }}
                        ghost
                      >
                        修改活动
                      </Button>
                    )}
                  </>
                }
                onBack={() => {
                  const params = decodeURIComponent(getQuery('query'));
                  history.push(`/activity-manage/myCreate/daily-activities-manager/scene?${params}`);
                }}
              />
            )} */}
          </div>
          <div className="rule-new-body-fa">
            <Microapp
              inhash="/integration/threshold"
              destory={true}
              /*   
                              poolId：底池ID，一直需要有，老逻辑
                              poolType：池类型，一个是正常规则池，另外是招商补录的规则池【按照龙啸的前一个接口说明，现在传了44】
                              planCode：活动code码，【营销中心提供】
                              ruleId：规则id，根据2里面不同池类型存储规则时，产生的规则id
                            */
              data={
                from === 'batch'
                  ? batchParams
                  : {
                      status: 'new', //这里和招商不一样，只传一个状态
                      poolType: 19, // 类型枚举：'19';
                      planCode: channelId, // 阵地id
                      ...postDataObj, //解构实现为空字段剔除
                    }
              }
              name="materialpoolrulesetting"
              url={env.ACE_DOMAIN + '/pandora/'}
            />
          </div>
          {from === 'batch' && status === 'new' && (
            <div className="batch-btn-wrapper">
              <Button type="primary" onClick={handelSaveRules}>
                保存并继续配置场次
              </Button>
            </div>
          )}
        </div>
      </Container>
    </ContextProviderMenus.Provider>
  );
});

export default MaterialPoolRuleNew;
